import React from 'react';
import { EditIcon, TrashIcon } from '../icons';
import { formatFileSize } from '../../utils/formatters';
import { retentionBadge } from '../../utils/retention';

const Folder = ({ 
  name = "Folder name",
  itemCount = 0,
  storageUsed = 0,
  retentionPeriod = null,
  date = "02.02.25",
  onClick,
  onEdit,
  onDelete,
  onRetentionEdit,
  className = ""
}) => {
  const badge = retentionBadge(retentionPeriod);

  const handleEditClick = (e) => {
    e.stopPropagation();
    if (onEdit) {
      onEdit(e);
    }
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete(e);
    }
  };

  return (
    <div onClick={onClick} className={`w-full h-[156px] bg-[#FCFCFC] dark:bg-[#1A1A1A] border border-[#ECECEC] dark:border-[#202020] rounded-3xl transition-all duration-200 hover:shadow-xl cursor-pointer ${className}`}>

      {/* Main View */}
      <div className="w-[calc(100%-1rem)] h-[100px] m-2 bg-[#FFFFFF] dark:bg-[#121212] border border-[#ECECEC] dark:border-[#202020] rounded-2xl">
        
        {/* Text Content */}
        <div className="p-4">
          <div className="text-xs font-medium text-[#7B7B7B] dark:text-[#848484] mb-1 flex items-center gap-1.5">
            <span>{itemCount} {itemCount === 1 ? 'item' : 'items'}{storageUsed > 0 && <> · {formatFileSize(storageUsed)}</>}</span>
            {badge && (
              <span className="px-1.5 py-0.5 rounded-md bg-[#F1F1F1] dark:bg-[#2A2A2A] text-[10px] font-medium text-[#7B7B7B] dark:text-[#848484]">
                {badge}
              </span>
            )}
          </div>
          <div className="text-sm font-semibold text-[#121212] dark:text-[#D0D0D0]">
            {name}
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="px-4 pb-2 flex items-center justify-between">
        {/* Left Side - Date */}
        <div className="text-xs font-medium text-[#7B7B7B] dark:text-[#848484]">
          {date}
        </div>

        {/* Right Side - Action Buttons */}
        <div className="flex items-center space-x-2">
          {/* Edit Button */}
          <button
            onClick={handleEditClick}
            className="hidden w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 hover:bg-[#F1F1F1] dark:hover:bg-[#2A2A2A]"
          >
            <EditIcon size={16} className="text-[#7B7B7B] dark:text-[#848484]" />
          </button>

          {/* Retention Edit Button */}
          {onRetentionEdit && (
            <button
              onClick={(e) => { e.stopPropagation(); onRetentionEdit(e); }}
              title="Edit retention"
              className="w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 hover:bg-[#F1F1F1] dark:hover:bg-[#2A2A2A]"
            >
              <EditIcon size={16} className="text-[#7B7B7B] dark:text-[#848484]" />
            </button>
          )}

          {/* Delete Button */}
          <button
            onClick={handleDeleteClick}
            className="w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 hover:bg-[#F1F1F1] dark:hover:bg-[#2A2A2A]"
          >
            <TrashIcon size={16} className="text-[#7B7B7B] dark:text-[#848484]" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Folder;
